var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 88,
    viewBox: "0 0 164 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.28 85.8074C29.9281 85.8074 38.56 77.1755 38.56 66.5275C38.56 55.8794 29.9281 47.2474 19.28 47.2474C8.63195 47.2474 0 55.8794 0 66.5275C0 77.1755 8.63195 85.8074 19.28 85.8074Z",
    fill: "#1E374B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.01 85.8175H58.68L10.96 3.16745H52.29L100.01 85.8175Z",
    fill: "#1E374B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155.97 11.8274C140.96 -3.18255 116.63 -3.18255 101.62 11.8274C86.61 26.8374 86.61 51.1674 101.62 66.1774L155.97 11.8274Z",
    fill: "#1E374B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M152.49 21.6074C167.5 36.6174 167.5 60.9474 152.49 75.9574C137.48 90.9674 113.15 90.9674 98.14 75.9574L152.49 21.6074Z",
    fill: "#1E374B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.af9680ddc026d76f78952a74a253c9c1.svg";
export { ForwardRef as ReactComponent };